import React from 'react';
import { useFormikContext } from 'formik';
import { Button, Grid } from 'ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons';

interface INewContactTypeButtonPairProps {
  preExistingContact: boolean;
  setAddPreExistingContactForm: (bool: boolean) => void;
}

export const NewContactTypeButtonPair: React.FC<INewContactTypeButtonPairProps> = ({
  preExistingContact,
  setAddPreExistingContactForm,
}) => {
  const formik = useFormikContext();
  const handleClick = (bool: boolean): void => {
    setAddPreExistingContactForm(bool);
    formik.resetForm();
  };
  return (
    <Grid columnCount={2}>
      <Button type={'button'} intent={preExistingContact ? 'primary' : 'secondary'} onClick={() => handleClick(true)}>
        Existing Contact
      </Button>
      <Button type={'button'} intent={preExistingContact ? 'secondary' : 'primary'} onClick={() => handleClick(false)}>
        <FontAwesomeIcon icon={faUserPlus} /> Add New Contact
      </Button>
    </Grid>
  );
};
